import client from './client';

export default (function VoteService() {
  let service;

  if (!service) {
    service = client.service('votes');
  }

  return service;
}());
